import React from 'react'

export default function Divider(props) {
  return (
    <div className='divider' {...props}>
      &nbsp;
    </div>
  )
}
